import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import CardBackgroundImageImpl from './card-background-image.js';

/**
 * The CardBackgroundImage component renders an image positioned absolutely to fill its container, intended to be used as a card background.
 *
 * @class CardBackgroundImage
 * @memberof Mojito.Presentation.Components
 */

/**
 * `CardBackgroundImage` component prop types.
 *
 * @property {string} src - Path to image resource or the sprite's id within the spritemap.
 * @property {Function} [onError] - Callback triggered on image load error.
 *
 * @memberof Mojito.Presentation.Components.CardBackgroundImage
 */
const propTypes = {
    src: PropTypes.string.isRequired,
    onError: PropTypes.func,
};

export default MojitoCore.Presentation.UIView(
    'CardBackgroundImage',
    CardBackgroundImageImpl,
    propTypes
);
